export default __webpack_public_path__ + "static/bin-it-right-logo-with-splash-7b4763b51545892f59eb580962ccc8dd.svg";